import { Text, View } from '@react-pdf/renderer';

import { Contract } from '@/types/ContractType';
import { styles } from '../style';
import AsbestosInspection from './AsbestosInspection';
import ElectricalInspection from './ElectricalInspection';
import EnvironmentalInspection from './EnvironmentalInspection';
import HvacInspection from './HvacInspection';
import InsectInspection from './InsectInspection';
import LeasebasedPaintInspextion from './LeasebasedPaintInspextion';
import MoldInspection from './MoldInspection';
import PoolInspection from './PoolInspection';
import RadonInspection from './RadonInspection';
import RoofInspection from './RoofInspection';
import SewerInspection from './SewerInspection';
import StructureInspection from './StructureInspection';
import WaterInspection from './WaterInspection';

const AdditionalInspection = ({ contract }: { contract: Contract }) => {
  const filteredInspections = (
    contract?.contingency?.additionalInspectionType || []
  ).filter((item) => item !== 'No Additional Inspection Required');

  if (filteredInspections.length === 0) {
    return (
      <View style={styles.section}>
        <Text style={styles.title}>ADDITIONAL INSPECTIONS</Text>
        <Text style={styles.text}>No Additional Inspection Required</Text>
      </View>
    );
  }

  return (
    <View style={styles.section}>
      <Text style={styles.title}>ADDITIONAL INSPECTIONS</Text>
      {filteredInspections.map((inspectionType, idx) => (
        <View style={styles.section} key={idx}>
          {inspectionType === 'Water' && (
            <WaterInspection contract={contract} />
          )}
          {inspectionType === 'Sewer' && (
            <SewerInspection
              homeinspectionNegotiationDays={
                contract?.contingency?.homeinspectionNegotiationDays
              }
            />
          )}
          {inspectionType === 'Roof' && (
            <RoofInspection
              homeinspectionNegotiationDays={
                contract?.contingency?.homeinspectionNegotiationDays
              }
            />
          )}
          {inspectionType === 'Insect' && (
            <InsectInspection
              homeinspectionNegotiationDays={
                contract?.contingency?.homeinspectionNegotiationDays
              }
            />
          )}
          {inspectionType === 'Structure' && (
            <StructureInspection
              homeinspectionNegotiationDays={
                contract?.contingency?.homeinspectionNegotiationDays
              }
            />
          )}
          {inspectionType === 'Environmental' && (
            <EnvironmentalInspection
              homeinspectionNegotiationDays={
                contract?.contingency?.homeinspectionNegotiationDays
              }
            />
          )}
          {inspectionType === 'Radon' && (
            <RadonInspection
              homeinspectionNegotiationDays={
                contract?.contingency?.homeinspectionNegotiationDays
              }
            />
          )}
          {inspectionType === 'Mold' && (
            <MoldInspection
              homeinspectionNegotiationDays={
                contract?.contingency?.homeinspectionNegotiationDays
              }
            />
          )}
          {inspectionType === 'Lease-Based Paint' && (
            <LeasebasedPaintInspextion
              homeinspectionNegotiationDays={
                contract?.contingency?.homeinspectionNegotiationDays
              }
            />
          )}
          {inspectionType === 'Asbestos' && (
            <AsbestosInspection
              homeinspectionNegotiationDays={
                contract?.contingency?.homeinspectionNegotiationDays
              }
            />
          )}
          {inspectionType === 'Electrical' && (
            <ElectricalInspection
              homeinspectionNegotiationDays={
                contract?.contingency?.homeinspectionNegotiationDays
              }
            />
          )}
          {inspectionType === 'HVAC' && (
            <HvacInspection
              homeinspectionNegotiationDays={
                contract?.contingency?.homeinspectionNegotiationDays
              }
            />
          )}
          {inspectionType === 'Pool' && (
            <PoolInspection
              homeinspectionNegotiationDays={
                contract?.contingency?.homeinspectionNegotiationDays
              }
            />
          )}
          {![
            'Water',
            'Sewer',
            'Roof',
            'Insect',
            'Structure',
            'Environmental',
            'Radon',
            'Mold',
            'Lease-Based Paint',
            'Asbestos',
            'Electrical',
            'HVAC',
            'Pool',
          ].includes(inspectionType) && (
            <View style={styles.section}>
              <Text style={styles.text}>
                <strong>{inspectionType} Inspection Clause:</strong>
              </Text>
              <Text style={styles.text}>
                The Buyer reserves the right to conduct a{' '}
                {inspectionType.toLowerCase()} inspection of the property within
                the specified timeframe. The results of this inspection may
                affect the terms of this contract.
              </Text>
            </View>
          )}
        </View>
      ))}
    </View>
  );
};

export default AdditionalInspection;
